export const USER_NOTES_CHANGED_EVENT = 'user-notes-changed';

export function notifyUserNotesChanged(): void {
  window.dispatchEvent(new CustomEvent(USER_NOTES_CHANGED_EVENT));
}
